import { createContext } from "react";
import OverlayScrollbars from "overlayscrollbars";

/**
 * Kontext pro nastavení barvy pozadí pro ActionItem komponenty. Výchozí hodnota je false = barva pozadí menu. Submenu poskytuje
 * pro všechny své potomky hodnotu true = barva pozadí submenu.
 */
export const ActionItemBackgroundContext = createContext(false);

export type ScrollContextType = OverlayScrollbars["scroll"] | null;

/**
 * Kontext pro předání funkce scroll z OverlayScrollbars. Umožňuje scrollovat na element s nastavením "center".
 * Nativní funkce scrollIntoView nepodporuje nastavením "center" v prohlížeči Safari.
 */
export const ScrollContext = createContext<ScrollContextType>(null);
